import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom'; 

const ShubhVivahHome = () => {
  const [activeTab, setActiveTab] = useState('community-matrimony');
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [tabSearchTerm, setTabSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('relevance'); // 'relevance', 'price-asc', 'price-desc'
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(500000); // Default max, will be adjusted per tab
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]); // Default to today
  const [endDate, setEndDate] = useState(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]); // Default to +7 days
  const [startTime, setStartTime] = useState('09:00'); // Default start time
  const [endTime, setEndTime] = useState('18:00'); // Default end time
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]); // Dynamic slots based on date
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [currentViewMonth, setCurrentViewMonth] = useState(new Date().getMonth()); // For multi-month navigation

  // Updated tabs based on services array
  const tabs = [
    { id: 'community-matrimony', label: '👥 Community Matrimony', emoji: '👨‍👩‍👧‍👦', category: 'Community Matrimony' },
    { id: 'marriage-registration', label: '📝 Marriage Registration', emoji: '📄', category: 'Marriage Registration' },
    { id: 'horoscope-kundli', label: '⭐ Horoscope / Kundli', emoji: '🔮', category: 'Horoscope / Kundli' },
    { id: 'venues', label: '📍 Venues', emoji: '🏛️', category: 'Venues' },
    { id: 'printed-invitation-cards', label: '📜 Printed Invitation Cards', emoji: '✉️', category: 'Printed Invitation Cards' },
    { id: 'digital-invitation-cards', label: '💻 Digital Invitation Cards', emoji: '📧', category: 'Digital Invitation Cards' },
    { id: 'catering', label: '🍲 Catering', emoji: '🥘', category: 'Catering' },
    { id: 'decoration', label: '💎 Decoration', emoji: '🎀', category: 'Decoration' },
    { id: 'music-entertainment', label: '🎵 Music & Entertainment', emoji: '🎼', category: 'Music & Entertainment' },
    { id: 'mehendi', label: '🖌️ Mehendi', emoji: '🌿', category: 'Mehendi' },
    { id: 'sangeet-ceremony', label: '🎤 Sangeet Ceremony', emoji: '💃', category: 'Sangeet Ceremony' },
    { id: 'band-baja', label: '🥁 Band-Baja', emoji: '🎺', category: 'Band-Baja' },
    { id: 'ghodiwala', label: '🐎 Ghodiwala', emoji: '🏇', category: 'Ghodiwala' },
    { id: 'fireworks', label: '🎆 Fireworks', emoji: '✨', category: 'Fireworks' },
    { id: 'bhade-ka-baarati', label: '👥 Bhade ka Baarati', emoji: '🚶‍♂️', category: 'Bhade ka Baarati' },
    { id: 'bridal-groom-wears', label: '👗 Bridal & Groom Wears', emoji: '👰‍♀️', category: 'Bridal & Groom Wears', route: '/orderflow-home' }, // Mapped to shopping route
    { id: 'relative-wears', label: '👔 Relative Wears', emoji: '👨‍👩‍👧', category: 'Relative Wears' },
    { id: 'makeup-artists', label: '💄 Makeup Artists', emoji: '🪞', category: 'Makeup Artists' },
    { id: 'planners-event-managers', label: '📅 Planners & Event Managers', emoji: '📋', category: 'Planners & Event Managers' },
    { id: 'photographers', label: '📸 Photographers', emoji: '📷', category: 'Photographers' },
    { id: 'priests-pandits', label: '🙏 Priests & Pandits', emoji: '🕉️', category: 'Priests & Pandits' },
    { id: 'pickup-drops', label: '🚐 Pickup & Drops', emoji: '🚗', category: 'Pickup & Drops' },
    { id: 'guest-accommodation', label: '🏨 Guest Accommodation', emoji: '🛏️', category: 'Guest Accommodation' },
    { id: 'guest-guides', label: '🗺️ Guest Guides', emoji: '🧭', category: 'Guest Guides' },
    { id: 'honeymoon-beyond', label: '✈️ Honeymoon & Beyond', emoji: '🍹', category: 'Honeymoon & Beyond', route: '/honeymoonlight' }, // Mapped to honeymoon route
    { id: 'unlisted', label: '❓ Unlisted', emoji: '🤔', category: 'Unlisted', route: '/giftify' }, // Mapped to gifts route for generality
  ];

  // Detailed dummy data for each tab (abbreviated; add availableDates, availableTimes, and recurringPatterns to all in full implementation)
  const dummyData = {
    'community-matrimony': [
      { id: 1, name: 'Brahmin Community Group', members: 1200, description: 'Traditional matchmaking for Brahmin families in North India', location: 'Delhi NCR', price: 0, emoji: '👥', availableDates: ['2025-11-15', '2025-12-01'], availableTimes: { '2025-11-15': ['10:00-12:00', '14:00-16:00'], '2025-12-01': ['09:00-11:00', '15:00-17:00'] }, recurringPatterns: { daysOfWeek: [1, 3], times: ['10:00-12:00', '14:00-16:00'] } }, // Mon, Wed
      { id: 2, name: 'Gujarati Matrimony Circle', members: 850, description: 'Vibrant community for Gujarati professionals seeking life partners', location: 'Mumbai', price: 0, emoji: '👨‍👩‍👧‍👦', availableDates: ['2025-10-30', '2025-11-20'], availableTimes: { '2025-10-30': ['11:00-13:00'], '2025-11-20': ['10:00-14:00', '16:00-18:00'] }, recurringPatterns: { daysOfWeek: [2, 4, 6], times: ['11:00-13:00'] } }, // Tue, Thu, Sat
      { id: 3, name: 'Tamil Elite Network', members: 650, description: 'Premium service for educated Tamil singles', location: 'Chennai', price: 5000, emoji: '👪', availableDates: ['2025-11-10', '2025-12-05'], availableTimes: { '2025-11-10': ['09:00-12:00', '14:00-17:00'], '2025-12-05': ['13:00-15:00'] }, recurringPatterns: { daysOfWeek: [0, 5], times: ['09:00-12:00'] } }, // Sun, Fri
      { id: 4, name: 'Punjabi Wedding Hub', members: 950, description: 'Fun and cultural matches for Punjabi youth', location: 'Amritsar', price: 0, emoji: '🕺', availableDates: ['2025-11-01', '2025-11-25'], availableTimes: { '2025-11-01': ['10:00-11:00', '12:00-13:00'], '2025-11-25': ['09:00-18:00'] }, recurringPatterns: { daysOfWeek: [1, 2, 3, 4, 5], times: ['09:00-18:00'] } }, // Mon-Fri
    ],
    'venues': [
      { id: 1, name: 'Grand Heritage Palace', capacity: 500, location: 'Jaipur', price: 250000, features: 'AC halls, parking, AV setup', emoji: '🏛️', availableDates: ['2025-11-15', '2025-11-20', '2025-12-01'], availableTimes: { '2025-11-15': ['08:00-12:00', '14:00-18:00', '19:00-22:00'], '2025-11-20': ['09:00-17:00'], '2025-12-01': ['10:00-20:00'] }, recurringPatterns: { daysOfWeek: [0, 6], times: ['08:00-22:00'] } }, // Sun, Sat (weekends)
      { id: 2, name: 'Lakeside Banquet', capacity: 300, location: 'Udaipur', price: 180000, features: 'Outdoor lawn, lake view, catering tie-up', emoji: '🌊', availableDates: ['2025-10-28', '2025-11-05', '2025-11-12'], availableTimes: { '2025-10-28': ['12:00-16:00'], '2025-11-05': ['08:00-22:00'], '2025-11-12': ['14:00-20:00'] }, recurringPatterns: { daysOfWeek: [3, 4], times: ['12:00-20:00'] } }, // Wed, Thu
      { id: 3, name: 'Urban Rooftop Terrace', capacity: 200, location: 'Bangalore', price: 120000, features: 'Modern decor, city skyline, valet', emoji: '🏙️', availableDates: ['2025-11-18', '2025-11-22'], availableTimes: { '2025-11-18': ['18:00-23:00'], '2025-11-22': ['10:00-14:00', '16:00-20:00'] }, recurringPatterns: { daysOfWeek: [5], times: ['18:00-23:00'] } }, // Fri evenings
      { id: 4, name: 'Temple Garden Resort', capacity: 400, location: 'Tirupati', price: 300000, features: 'Spiritual ambiance, eco-friendly, pool', emoji: '🛕', availableDates: ['2025-12-10', '2025-12-15'], availableTimes: { '2025-12-10': ['07:00-12:00', '15:00-19:00'], '2025-12-15': ['09:00-21:00'] }, recurringPatterns: { daysOfWeek: [0, 1, 2, 3, 4, 5, 6], times: ['07:00-21:00'] } }, // All days
    ],
    // ... (add to other tabs as needed)
  };

  // Filter tabs based on global search
  const filteredTabs = tabs.filter(tab =>
    tab.label.toLowerCase().includes(globalSearchTerm.toLowerCase()) ||
    tab.category.toLowerCase().includes(globalSearchTerm.toLowerCase())
  );

  // Function to get price/cost for sorting and filtering (normalize to number)
  const getItemPrice = (item) => {
    const price = item.price || item.cost || item.fees || 0;
    return typeof price === 'string' ? parseInt(price.replace(/[₹,]/g, '')) || 0 : price;
  };

  // Compute min/max price for active tab
  const priceRange = useMemo(() => {
    const data = dummyData[activeTab] || [];
    const prices = data.map(getItemPrice).filter(p => p > 0);
    const minP = prices.length > 0 ? Math.min(...prices) : 0;
    const maxP = prices.length > 0 ? Math.max(...prices) : 500000;
    setMinPrice(prev => Math.max(minP, Math.min(prev, maxP)));
    setMaxPrice(prev => Math.min(maxP, Math.max(minP, prev)));
    return { min: minP, max: maxP };
  }, [activeTab]);

  // Generate calendar for a specific month/year
  const generateCalendarDays = (month, year) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({ day, dateStr: `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}` });
    }
    while (days.length % 7 !== 0) {
      days.push(null);
    }
    return { monthName: new Date(year, month).toLocaleString('default', { month: 'short' }), days };
  };

  // Multi-month: Generate 3 months starting from currentViewMonth
  const multiMonthCalendars = useMemo(() => {
    const calendars = [];
    for (let i = 0; i < 3; i++) {
      const month = (currentViewMonth + i) % 12;
      const year = currentViewMonth + i >= 12 ? selectedYear + 1 : selectedYear;
      calendars.push(generateCalendarDays(month, year));
    }
    return calendars;
  }, [currentViewMonth, selectedYear]);

  // Dummy available dates for selected item (now includes recurring)
  const getAvailableDates = useMemo(() => {
    if (!selectedItem) return [];
    const fixedDates = selectedItem.availableDates || [];
    const recurringDates = [];
    if (selectedItem.recurringPatterns) {
      const { daysOfWeek, times } = selectedItem.recurringPatterns;
      // Generate recurring dates for next 3 months (simplified)
      const today = new Date('2025-10-23'); // Current date
      const endOfPeriod = new Date(today);
      endOfPeriod.setMonth(endOfPeriod.getMonth() + 3);
      for (let d = new Date(today); d <= endOfPeriod; d.setDate(d.getDate() + 1)) {
        if (daysOfWeek.includes(d.getDay())) {
          const dateStr = d.toISOString().split('T')[0];
          recurringDates.push(dateStr);
        }
      }
    }
    return [...new Set([...fixedDates, ...recurringDates])]; // Unique
  }, [selectedItem]);

  const availableDates = getAvailableDates;

  // Check if date is available
  const isDateAvailable = (dayObj) => {
    if (!dayObj) return false;
    return availableDates.includes(dayObj.dateStr);
  };

  // Handle date selection (updated for multi-month)
  const handleDateClick = (dayObj, month, year) => {
    if (!dayObj || !isDateAvailable(dayObj)) return;
    const dateStr = dayObj.dateStr;
    if (!startDate || new Date(dateStr) < new Date(startDate)) {
      setStartDate(dateStr);
      setEndDate('');
    } else if (!endDate) {
      setEndDate(dateStr);
    } else if (new Date(dateStr) > new Date(endDate)) {
      setEndDate(dateStr);
    } else {
      setStartDate(dateStr);
      setEndDate('');
    }
  };

  // Update available time slots when startDate changes (now includes recurring)
  useEffect(() => {
    if (selectedItem && startDate) {
      let slots = [];
      // Check fixed times first
      if (selectedItem.availableTimes && selectedItem.availableTimes[startDate]) {
        slots = selectedItem.availableTimes[startDate];
      }
      // If no fixed, check recurring
      if (slots.length === 0 && selectedItem.recurringPatterns && selectedItem.recurringPatterns.times) {
        const date = new Date(startDate);
        if (selectedItem.recurringPatterns.daysOfWeek.includes(date.getDay())) {
          slots = selectedItem.recurringPatterns.times;
        }
      }
      setAvailableTimeSlots(slots);
      // Set default to first slot if available
      if (slots.length > 0 && !startTime) {
        const firstSlot = slots[0];
        const [startSlotTime, endSlotTime] = firstSlot.split('-');
        setStartTime(startSlotTime);
        setEndTime(endSlotTime);
      } else {
        setStartTime('09:00');
        setEndTime('18:00');
      }
    } else {
      setAvailableTimeSlots([]);
    }
  }, [startDate, selectedItem]);

  // Handle time slot selection
  const handleSlotSelect = (slot) => {
    const [slotStart, slotEnd] = slot.split('-');
    setStartTime(slotStart);
    setEndTime(slotEnd);
  };

  // Filter and sort data for active tab
  const getFilteredData = (tabId) => {
    let data = dummyData[tabId] || [];
    if (tabSearchTerm) {
      data = data.filter(item => {
        const searchableText = JSON.stringify(item).toLowerCase();
        return searchableText.includes(tabSearchTerm.toLowerCase());
      });
    }
    data = data.filter(item => {
      const itemPrice = getItemPrice(item);
      return itemPrice >= minPrice && itemPrice <= maxPrice;
    });
    if (sortBy === 'price-asc') {
      data.sort((a, b) => getItemPrice(a) - getItemPrice(b));
    } else if (sortBy === 'price-desc') {
      data.sort((a, b) => getItemPrice(b) - getItemPrice(a));
    }
    return data;
  };

  const renderTabContent = (activeTabId) => {
    const activeTabObj = tabs.find(tab => tab.id === activeTabId);
    const data = getFilteredData(activeTabId);
    const hasRoute = activeTabObj?.route;
    const displayKey = activeTabId.includes('match') ? 'match' : activeTabId.includes('step') ? 'step' : activeTabId.includes('design') ? 'design' : activeTabId.includes('menu') ? 'menu' : activeTabId.includes('theme') ? 'theme' : activeTabId.includes('artist') ? 'artist' : activeTabId.includes('event') ? 'event' : activeTabId.includes('group') ? 'group' : activeTabId.includes('type') ? 'type' : activeTabId.includes('display') ? 'display' : activeTabId.includes('item') ? 'item' : activeTabId.includes('service') ? 'service' : activeTabId.includes('package') ? 'package' : activeTabId.includes('ritual') ? 'ritual' : activeTabId.includes('hotel') ? 'hotel' : activeTabId.includes('destination') ? 'destination' : 'name';

    if (data.length === 0) {
      return (
        <div className="p-4 text-center">
          <p className="opacity-70">No results found. Try adjusting your filters! 🔍</p>
        </div>
      );
    }

    return (
      <div className="p-4">
        <h3 className="text-lg font-bold mb-2">{activeTabObj?.label} {activeTabObj?.emoji}</h3>
        
        {/* Tab-specific filters */}
        <div className="space-y-4 mb-4">
          <div className="bg-gray-700 p-3 rounded">
            <input
              type="text"
              placeholder="Search within this tab... 🔍"
              value={tabSearchTerm}
              onChange={(e) => setTabSearchTerm(e.target.value)}
              className="w-full px-3 py-2 bg-gray-800 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          {/* Price Range Sliders */}
          <div className="bg-gray-700 p-3 rounded">
            <label className="block text-sm font-medium mb-2">Price Range: ₹{minPrice.toLocaleString()} - ₹{maxPrice.toLocaleString()} 💰</label>
            <div className="flex flex-col sm:flex-row gap-4 items-center">
              <div className="flex-1">
                <label className="block text-xs opacity-70 mb-1">Min Price</label>
                <input
                  type="range"
                  min={priceRange.min}
                  max={priceRange.max}
                  value={minPrice}
                  onChange={(e) => setMinPrice(parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer slider"
                  style={{
                    background: `linear-gradient(to right, #3b82f6 ${((minPrice - priceRange.min) / (priceRange.max - priceRange.min)) * 100}%, #4b5563 ${((minPrice - priceRange.min) / (priceRange.max - priceRange.min)) * 100}%)`,
                  }}
                />
                <output className="text-xs opacity-70">₹{minPrice.toLocaleString()}</output>
              </div>
              <span className="hidden sm:block text-gray-400">—</span>
              <div className="flex-1">
                <label className="block text-xs opacity-70 mb-1">Max Price</label>
                <input
                  type="range"
                  min={priceRange.min}
                  max={priceRange.max}
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer slider"
                  style={{
                    background: `linear-gradient(to right, #4b5563 ${(maxPrice - priceRange.min) / (priceRange.max - priceRange.min) * 100}%, #3b82f6 ${(maxPrice - priceRange.min) / (priceRange.max - priceRange.min) * 100}%)`,
                  }}
                />
                <output className="text-xs opacity-70">₹{maxPrice.toLocaleString()}</output>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 bg-gray-700 p-3 rounded">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="flex-1 px-3 py-2 bg-gray-800 rounded text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="relevance">Sort by Relevance</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
            </select>
            <button
              onClick={() => {
                setTabSearchTerm('');
                setSortBy('relevance');
                setMinPrice(priceRange.min);
                setMaxPrice(priceRange.max);
              }}
              className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500 transition-colors"
            >
              Clear All Filters 🗑️
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data.map((item) => {
            const itemPrice = getItemPrice ? getItemPrice(item) : 0;
            return (
              <div
                key={item.id || item.name}
                className="bg-gray-800 p-3 rounded mb-2 flex flex-col items-center"
              >
                <span className="text-2xl mr-2">{item.emoji}</span>

                <div className="flex-1">
                  <p className="font-semibold">
                    {item[displayKey] || item.name || item.placeholder || "Unnamed"}
                  </p>

                  <p className="text-sm opacity-70">
                    {item.description ||
                      item.status ||
                      item.location ||
                      item.style ||
                      item.genre ||
                      "Details"}
                    {itemPrice > 0 && (
                      <span className="block">₹{itemPrice.toLocaleString()}</span>
                    )}
                  </p>
                </div>

                <button
                  onClick={() => {
                    setSelectedItem(item);
                    setBookingModalOpen(true);
                  }}
                  className="ml-auto bg-green-600 px-3 py-1 w-20 rounded text-sm hover:bg-green-700 transition-colors"
                >
                  Book 📅
                </button>
              </div>
            );
          })}
        </div>

        {hasRoute && (
          <div className="text-center mt-4">
            <Link to={activeTabObj.route} className="bg-purple-600 px-4 py-2 rounded inline-block hover:bg-purple-700 transition-colors">Proceed to {activeTabObj.category} Flow 🚀</Link>
          </div>
        )}
        <p className="text-xs opacity-50 mt-2 text-center">Showing {data.length} of {dummyData[activeTabId]?.length || 0} results</p>
      </div>
    );
  };

  // Booking Modal
  const BookingModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-4xl max-h-[95vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">Book {selectedItem?.name || selectedItem?.item || selectedItem?.service} 📅</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-2">Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              className="w-full px-3 py-2 bg-gray-700 rounded text-white"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              className="w-full px-3 py-2 bg-gray-700 rounded text-white"
            />
          </div>
        </div>
        {/* Time Slot Availability */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Available Time Slots for {startDate} ⏰</label>
          {availableTimeSlots.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {availableTimeSlots.map((slot, idx) => (
                <button
                  key={idx}
                  onClick={() => handleSlotSelect(slot)}
                  className={`px-3 py-2 rounded text-sm border transition-colors ${
                    startTime === slot.split('-')[0] && endTime === slot.split('-')[1]
                      ? 'bg-blue-600 text-white border-blue-500'
                      : 'bg-gray-700 hover:bg-gray-600 border-gray-500'
                  }`}
                >
                  {slot}
                </button>
              ))}
            </div>
          ) : (
            <p className="text-sm opacity-70">No time slots available for this date. Select another date. ⚠️</p>
          )}
        </div>
        {/* Manual Time Inputs (fallback if no slots) */}
        {availableTimeSlots.length === 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-2">Start Time</label>
              <input
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                className="w-full px-3 py-2 bg-gray-700 rounded text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">End Time</label>
              <input
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                min={startTime}
                className="w-full px-3 py-2 bg-gray-700 rounded text-white"
              />
            </div>
          </div>
        )}
        {/* Multi-Month Calendar View */}
        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <button onClick={() => setCurrentViewMonth(prev => (prev - 3 + 12) % 12)} className="text-blue-400 text-lg">‹‹</button>
            <h3 className="text-sm font-medium">Available Dates (3 Months View)</h3>
            <button onClick={() => setCurrentViewMonth(prev => (prev + 3) % 12)} className="text-blue-400 text-lg">››</button>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {multiMonthCalendars.map((cal, idx) => {
              const monthOffset = currentViewMonth + idx >= 12 ? 1 : 0;
              const calYear = selectedYear + monthOffset;
              const calMonth = (currentViewMonth + idx) % 12;
              return (
                <div key={idx} className="bg-gray-700 p-3 rounded">
                  <h4 className="text-center text-xs font-bold mb-1">{cal.monthName} {calYear}</h4>
                  <div className="grid grid-cols-7 gap-1 text-center text-xs">
                    {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
                      <div key={day} className="font-semibold py-1">{day}</div>
                    ))}
                    {cal.days.map((dayObj, dayIdx) => (
                      <button
                        key={dayIdx}
                        onClick={() => handleDateClick(dayObj, calMonth, calYear)}
                        className={`py-1 px-1 rounded text-xs border transition-colors ${
                          !dayObj ? 'invisible' :
                          isDateAvailable(dayObj) ? 'bg-green-600 text-white border-green-500 hover:bg-green-500' :
                          startDate && dayObj.dateStr === startDate ? 'bg-blue-600 text-white border-blue-500' :
                          endDate && dayObj.dateStr === endDate ? 'bg-blue-600 text-white border-blue-500' :
                          'bg-gray-600 text-gray-300 hover:bg-gray-500 border-gray-500'
                        }`}
                        disabled={!dayObj || !isDateAvailable(dayObj)}
                      >
                        {dayObj ? dayObj.day : ''}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <p className="text-xs opacity-70 mt-2 text-center">
            Green days are available (including recurring patterns). Click to select start/end range. {availableDates.length} dates available overall.
          </p>
        </div>
        <div className="flex gap-2 justify-end flex-wrap">
          <button
            onClick={() => {
              setBookingModalOpen(false);
              setSelectedItem(null);
              setStartDate(new Date().toISOString().split('T')[0]);
              setEndDate(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
              setStartTime('09:00');
              setEndTime('18:00');
              setAvailableTimeSlots([]);
              setCurrentViewMonth(new Date().getMonth());
            }}
            className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500"
          >
            Cancel ❌
          </button>
          <button
            onClick={() => {
              // Dummy booking logic; in real, send to backend
              if (new Date(endDate + 'T' + endTime) <= new Date(startDate + 'T' + startTime)) {
                alert('End time must be after start time! ⏰');
                return;
              }
              alert(`Booked ${selectedItem?.name} from ${startDate}T${startTime} to ${endDate}T${endTime}! 💍`);
              setBookingModalOpen(false);
              setSelectedItem(null);
            }}
            disabled={!startDate || !endDate || !startTime || !endTime}
            className="px-4 py-2 bg-green-600 rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Confirm Booking ✅
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-900 text-white p-2">
      {/* Header */}
      <header className="text-center mb-4">
        <h1 className="text-3xl font-bold">💍ShubhVivah</h1>
        <p className="opacity-70">Your End-to-End Wedding Journey</p>
      </header>

      {/* Global Search */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search services (e.g., 'catering' or 'Mumbai')... 🔍"
          value={globalSearchTerm}
          onChange={(e) => {
            setGlobalSearchTerm(e.target.value);
            if (e.target.value) {
              const firstMatch = filteredTabs[0];
              if (firstMatch && activeTab !== firstMatch.id) {
                setActiveTab(firstMatch.id);
              }
            }
          }}
          className="w-full px-4 py-2 bg-gray-800 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Tab Navigation - Filtered tabs */}
      <nav className="overflow-x-auto pb-2 mb-4 whitespace-nowrap grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-9 gap-1 md:gap-2">
        {filteredTabs.length > 0 ? (
          filteredTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => !tab.route && setActiveTab(tab.id)}
              className={`flex flex-col items-center p-2 rounded text-xs md:text-sm min-w-[80px] transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-800 hover:bg-gray-700'
              }`}
            >
              <span className="text-2xl mb-1">{tab.emoji}</span>
              <span className="truncate">{tab.label}</span>
            </button>
          ))
        ) : (
          <p className="col-span-full text-center opacity-70 p-4">No services match your search. Try something else! 😊</p>
        )}
      </nav>

      {/* Tab Content */}
      <main className="bg-gray-800 rounded-lg p-0 md:p-4">
        {filteredTabs.length > 0 ? renderTabContent(activeTab) : null}
      </main>

      {/* Booking Modal */}
      {bookingModalOpen && <BookingModal />}

      {/* Footer - Progress Indicator */}
      <footer className="mt-8 text-center opacity-70">
        <p>Progress: {tabs.findIndex(t => t.id === activeTab) + 1}/{tabs.length} Services Explored 📈</p>
        {globalSearchTerm && <p className="text-sm">Filtered tabs: {filteredTabs.length}/{tabs.length}</p>}
      </footer>
    </div>
  );
};

export default ShubhVivahHome;